import React, { Component } from 'react'
import LoadingDots from '../LoadingDots'
import Overlay from '../../Overlay'

export default class LoadingOverlay extends Component {
  render() {
    return (
      <Overlay {...this.props}>
        <LoadingDots />
      </Overlay>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Loading/LoadingOverlay/LoadingOverlay.jsx